import React, {useContext, useState, useEffect} from 'react';
import { useNavigate, useParams, useLocation, useSearchParams  } from 'react-router-dom'; 
import * as Yup from 'yup';
import axios from 'axios';
import {BASE_URL} from '../config'
import swal from 'sweetalert'
import FileUploadProgress from '../Components/FileUploadProgress'
import {AuthContext} from '../context/AuthContext'
import utilities from '../utilities'
import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'

const UploadVerification = (props) => {

    let { registrationID} = useParams();
    const navigate = useNavigate();
    const [verificationProgress, setVerificationProgress] = useState(0);
    const [verificationRememainingTime, setVerificationRemainingTime] = useState(0);
    const[matricVerificationPath, setMatricVerificationPath] = useState('');
    const {userInfo} = useContext(AuthContext);

    const validFileExtensions = { image: ['jpg', 'png', 'jpeg'] };
    
    var rID = utilities.decryptData(registrationID);
    const {data} = useApi( {url: '/Registration/GetAppliationByID?RegistrationID=' + rID, method: 'get' });



    function isValidFileType(fileName, fileType) {
      return fileName && validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1;
    }
    
    function getAllowedExt(type) {
      return validFileExtensions[type].map((e) => `.${e}`).toString()
    } 
    
    let allowedExts = getAllowedExt('image');
    const MAX_FILE_SIZE = 102400;

    const myUploadProgress = (myFileId, startAt) => (progressEvent) => {

        const { loaded, total } = progressEvent;
        const percentage = (loaded * 100) / total;
        const timeElapsed = Date.now() - startAt;
        const uploadSpeed = loaded / timeElapsed;
        const duration = (total - loaded) / uploadSpeed;

        if (myFileId == "verification")
        {
            setVerificationProgress(+percentage.toFixed(2));
            setVerificationRemainingTime(duration);              
        }

      }


      const sleep = async (milliseconds) => {
        await new Promise(resolve => {
            return setTimeout(resolve, milliseconds)
        });
      };
    

  const handleFileUpload = (event) => {
    let startAt = Date.now();
    const file = event.target.files[0];
    var size = file.size;
    //if (size > MAX_FILE_SIZE)
    //{
    //  alert('only allowed 100 kb file size');
    //  return;
    //}
    const fd = new FormData();
    fd.append("file", file);
    axios
      .post(BASE_URL + "/Registration/UploadVerification?RegistrationID=" + rID, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress : myUploadProgress(event.target.name, startAt)

      })
      .then(async(response) => {
        setMatricVerificationPath(response.data);
        await sleep(5000);
        navigate('/registration/students');
      })
      .catch((error) => {
        console.log(error);
      });
  };



  useEffect(() => {

    
}, []);




  return (
    
    <>
    {!data ? (<Loader />) : (
        <div className="">

              <div className='col-12'>
                  <p class="text-uppercase fs-5 fw-bold">Upload Verification</p>
              </div>
              <hr></hr>

            <div className='d-flex flex-row flex-wrap mb-3'>
              <div style={{width: '200px'}}>
                <span  class="col-form-label fw-bold">Candidate Name</span>
              </div>                
                <div class="flex-fill">
                    <span>{data.studentName}</span>
                </div>
            </div>

            <div className='d-flex flex-row flex-wrap mb-3'>
              <div style={{width: '200px'}}>
                <span  class="col-form-label fw-bold">Father Name</span>
              </div>                
                <div class="flex-fill">
                    <span>{data.fatherName}</span>
                </div>
            </div>

            <div className='d-flex flex-row flex-wrap mb-3'>
              <div style={{width: '200px'}}>
                <span  class="col-form-label fw-bold">CNIC</span>
              </div>                
                <div class="flex-fill">
                    <span>{data.cnic}</span>
                </div>
            </div>


              <div className='col-12 mt-4 mb-3'>
                <label>Matric Board Verification</label>

                  <input type="file" class="form-control" name="verification" accept={allowedExts} onChange={(e) => {handleFileUpload(e)}}/>
                <FileUploadProgress progress={verificationProgress} remaining={verificationRememainingTime} />
                {matricVerificationPath ? (<>
                  <div><img src={matricVerificationPath} style={{maxWidth: '450px', maxHeight:'450px', marginTop: '5px'}} /></div>
                  <div><a href={matricVerificationPath} target='_blank'> View Large Document </a></div></>
                ) : <>
                  <div><img src={data.matricVerificationPath} style={{maxWidth: '450px', maxHeight:'450px', marginTop: '5px'}} /></div>
                  <div><a href={data.matricVerificationPath} target='_blank'> View Large Document </a></div></>
                 }                                
              </div> 




       </div>  
    )}
    </>
  );

};

export default UploadVerification;
